import {
  MotionFlex as Flex,
  MotionBox as Box,
  staggeredAppear,
  appearBelow,
} from "utils/motion";
import Text from "components/base/Text";
import Container from "components/base/Container";

export default function BigTitleSection({
  title,
  description,
  subtitle,
  children,
  isWide,
  inverted,
}) {
  return (
    <Box width="100%" bg={inverted ? "black.900" : "white"}>
      <Container small>
        <Flex
          variants={staggeredAppear}
          initial="hidden"
          whileInView="visible"
          direction="column"
          viewport={{ once: true, amount: 0.4 }}
          width="100%"
          alignItems={[isWide ? "flex-start" : "center", null, "center"]}
          justifyItems="center"
        >
          <Text
            type="headline_md"
            color={inverted ? "white" : "black.900"}
            variants={appearBelow}
            textAlign={[isWide ? "left" : "center", null, "center"]}
            width="80%"
            mb={[4, 4, 7]}
          >
            {title}
          </Text>
          <Text
            type="p_lg"
            color={inverted ? "white" : "black.900"}
            variants={appearBelow}
            textAlign={[isWide ? "left" : "center", null, "center"]}
            margin="auto"
            maxWidth={isWide ? "100%" : "xl"}
          >
            {description}
          </Text>
          {subtitle ? (
            <Text type="title_md" variants={appearBelow} pt="sm" pb="xs">
              {subtitle}
            </Text>
          ) : null}
          {children ? <Box variants={appearBelow}>{children}</Box> : null}
        </Flex>
      </Container>
    </Box>
  );
}
